"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioGroup = void 0;
const react_1 = __importStar(require("react"));
const RadixRadioGroup = __importStar(require("@radix-ui/react-radio-group"));
const uuid_1 = require("uuid");
const Text_1 = require("../../../components/Text/Text");
const RadioGroup_styles_1 = require("./RadioGroup.styles");
const RadioGroupRoot = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { appearance, children, dir } = _a, props = __rest(_a, ["appearance", "children", "dir"]);
    return (react_1.default.createElement(RadioGroup_styles_1.StyledRadioGroupRoot, Object.assign({ ref: forwardedRef, "$appearance": appearance }, props, { dir: dir }), children));
});
const RadioGroupItem = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(RadioGroup_styles_1.StyledRadioGroupItem, Object.assign({ ref: forwardedRef }, props), children));
});
const RadioGroupIndicator = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var props = __rest(_a, []);
    // I wish I could use React 18 useId() here
    const uniqueId = (0, uuid_1.v4)();
    return (react_1.default.createElement(RadioGroup_styles_1.StyledRadioGroupIndicator, Object.assign({ ref: forwardedRef }, props),
        react_1.default.createElement(RadioGroup_styles_1.StyledIndicatorImage, { viewBox: "0 0 25 25", width: "1.5625rem", height: "1.5625rem", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true" },
            react_1.default.createElement("defs", null,
                react_1.default.createElement("clipPath", { id: uniqueId },
                    react_1.default.createElement("circle", { cx: "12.5", cy: "12.5", r: "8" }))),
            react_1.default.createElement(RadioGroup_styles_1.StyledIndicatorFocusRing, { cx: "12.5", cy: "12.5", r: "11", fill: "none" }),
            react_1.default.createElement(RadioGroup_styles_1.StyledIndicatorOuterRing, { cx: "12.5", cy: "12.5", r: "8", fill: "none", clipPath: `url(#${uniqueId})` })),
        react_1.default.createElement(RadixRadioGroup.Indicator, null,
            react_1.default.createElement(RadioGroup_styles_1.StyledIndicatorImage, { viewBox: "0 0 18 18", width: "1.25rem", height: "1.25rem", xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement(RadioGroup_styles_1.StyledIndicatorInnerDot, { cx: "9", cy: "9", r: "4" })))));
});
const RadioGroupLabel = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Text_1.Text, { as: "label", props: Object.assign({ ref: forwardedRef }, props), skinny: true }, children));
});
RadioGroupRoot.displayName = "RadioGroup";
RadioGroupItem.displayName = "RadioGroup.Item";
RadioGroupIndicator.displayName = "RadioGroup.Indicator";
RadioGroupLabel.displayName = "RadioGroup.Label";
exports.RadioGroup = Object.assign(RadioGroupRoot, {
    Item: RadioGroupItem,
    Indicator: RadioGroupIndicator,
    Label: RadioGroupLabel,
});
//# sourceMappingURL=RadioGroup.js.map